import React, { useState } from "react";
import { Button, Divider, Text, Modal } from "@mantine/core";
import axios from "axios";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

export default function RequestApiConnectionButton({
  locationId,
  organizationId,
}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [isOpen, setOpen] = useState(false);

  function onClose() {
    setOpen(false);
    setLoading(false);
  }

  function onClick() {
    const req = {};

    setLoading(true);

    if (locationId) req.location_id = locationId;
    if (organizationId) req.organization_id = organizationId;

    axios
      .post(`/request-api-connection/`, req)
      .then(() => {
        toast.success(t("common:success") + "!");
        setLoading(false);
        onClose();
      })
      .catch((err) => {
        toast.error(err);
        setLoading(false);
      });
  }

  return (
    <>
      <Button
        size="xs"
        variant="subtle"
        p={0}
        color="gray"
        onClick={() => setOpen(true)}
      >
        {t("mixer:api_connection:api_connection_button")}
      </Button>
      <Modal opened={isOpen} onClose={onClose}>
        <Text>
          {t("mixer:api_connection:request_api_connection_instructions")}
        </Text>
        <Divider mt="lg" mb="lg" />
        <Button fullWidth onClick={onClick} loading={loading}>
          {t("mixer:api_connection:make_request")}
        </Button>
      </Modal>
    </>
  );
}
